export const setSubscriptionDetailsActionType = "subscriptions/set/details";

export const setSubscriptionDetailsPostsActionType =
  "subscriptions/setDetailsPosts";

export const addSubscriptionDetailsPostsActionType =
  "subscriptions/addDetailsPosts";
